import WithLink from "features/common/components/WithLink";
import PrimaryButtonWhite from "./PrimaryButtonWhite";

export default WithLink(PrimaryButtonWhite);
